export default "__VITE_ASSET__ClZP4h7O__"